<script setup>
import { onMounted, ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import scheduler from '@/schedule';


import Navbar from '@/layouts/Navbars/Navbar.vue';
import AppFooter from '@/layouts/Footer.vue';

const store = useStore();
const route = useRoute();
const router = useRouter();

const appReady = ref(false);

onMounted(async () => {
  await router.isReady();
  appReady.value = true;
});

onMounted(() => {
  scheduler();
});

const layoutDisabledRoutes = ['/logout', '/confirmar-login-externo'];

const hideLayout = computed(() => {
  const cleanPath = route.path.replace(/\/+$/, '');
  return layoutDisabledRoutes.includes(cleanPath);
});

const layout = computed(() => store.state.layout);
const showFooter = computed(() => store.state.showFooter);
</script>

<template>
  <!-- Evita renderizar hasta que esté listo el router -->
  <template v-if="appReady">
    <!-- Fondo tipo landing -->
    <div
      v-show="layout === 'landing'"
      class="landing-bg h-100 bg-gradient-primary position-fixed w-100"
    ></div>

    <div v-if="!hideLayout">
      <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
        <navbar />
        <router-view />
        <app-footer v-show="showFooter" />
      </main>
    </div>
  </template>
</template>
